import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
@Component({
  selector: 'app-confirm-snackbar',
  templateUrl: './confirm-snackbar.component.html',
  styleUrls: ['./confirm-snackbar.component.css']
})
export class ConfirmSnackbarComponent implements OnInit {

  constructor(private bottomSheetRef: MatBottomSheetRef<ConfirmSnackbarComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
     }

  ngOnInit() {
  }

  positive(){
    this.bottomSheetRef.dismiss({
      response:true
    });
  }
  negative(){
    this.bottomSheetRef.dismiss({
      response:false
  });
    event.preventDefault();
  }

  

}
